/**
 * Created by intellicar-rinas on 21/10/17.
 */
import React, { Component } from 'react';
import InGraph from '../InGraph/InGraph2';
import './InGraphControl.css';
import Dom from '../../../../helpers/Dom';
import _ from 'lodash';
import { dateFormat } from '../../../../constants/constants';
import moment from 'moment';
import GeoCodeAPIs from '../../../../APIs/GeoCodeAPIs';
import ReportAPIs from '../../../../APIs/ReportAPIs';
import {connect} from 'react-redux';


const speedSet = [
    { name: '1/8x', speed: 1280 },
    { name: '1/4x', speed: 640 },
    { name: '1/2x', speed: 320 },
    { name: '1x', speed: 160 },
    { name: '2x', speed: 80 },
    { name: '4x', speed: 40 },
    { name: '8x', speed: 20 },
    { name: '16x', speed: 10 },
];

const devicemodel = [
    { type: ['intelliblu'], model: 'intelliblu' },
    { type: ['kle'], model: 'kle' },
    { type: ['ermtrackersf_edata','erm_starlinkone','cr300','caniq','sino',
    'teltonika_fmb920','teltonika_fmb001','teltonika_fmb207','concoxgt06n','concox_assettracker','concox_at4',
    'ermtogo','ermtrackersf','autocop','cello','nano','rdgps','volty_transync_ais140_v1','itriangle_bharat101', 
    'accord_navitrack257','jio_jvt1440','erm_evcan','teltonika_fmb208','teltonika_tft100'], model: 'GPS' },
];

class InGraphControl extends Component {

    state = {
        playing: false,
        speed: 3,
        brakeData: '',
        clutchData: '',
        accelData: '',
        mouseIn: false
    };

    graphData = {};

    currentIndex = 0;
    // componentDidMount(){
    //     document.getElementsByClassName("rwt-widget")[0].style.top="737.5px"
    // }

    componentWillUnmount() {
        this.unmounted = true;
    }

    constructor() {
        super();

        window.InGraphControlForceUpdate = () => {
            if (this.unmounted) return;
            clearTimeout(this.updateDebounce);
            this.updateDebounce = setTimeout(() => {
                this.forceUpdate();
            }, 100);
        };

        this.getConfig = () => {
            return {
                width: window.innerWidth - 50 - 330 - 210,
                height: this.props.data._position.height,
                type: 'controller'
            }
        };

        this.togglePlay = (action = null) => {
            if (window.graphControlData.length > 0) {
                let playing = action !== null ? action : !this.state.playing;
                window.pointerLocked = playing || window.pointerLocked;
                this.setState({ playing }, () => {
                    this.goto(this.currentIndex, playing);
                });
            }
        };

        this.seek = dir => {
            this.goto(this.currentIndex + dir);
        };

        this.updateTimeline = (time, update = true) => {
            if (this.unmounted) return;
            if (window.graphControlData) {
                let index = _.sortedIndexBy(window.graphControlData, { time }, o => { return o.time });
                this.goto(index, false, update);
            }
        };

        window.updateTimeline = this.updateTimeline;

        this.onMouseMoveInGraph2 = event => {
            if (this.unmounted) return;

            if (window.pointerMarker && window.graphControlData) {
                let index = _.sortedIndexBy(window.graphControlData, { time: event.time }, o => { return o.time });
                this.currentIndex = index;
                let data = window.graphControlData[index] || {};
                let pos = {
                    lat: data.latitude,
                    lng: data.longitude,
                };

                if (pos.lat === null || pos.lng === null)
                    return;

                if (pos.lat == 0 && pos.lng == 0)
                    return;

                if (pos.lng > -3 && pos.lng < 3)
                    return;

                window.pointerMarker.setVisible(true);
                window.pointerMarker.setPosition(pos);

                if (!checkIsMarkerInsideView(window.pointerMarker)) {
                    window.map.panTo(pos);
                }

            }
        };

        this.fetchAddress = event => {
            let index = _.sortedIndexBy(window.graphControlData, { time: event.time }, o => { return o.time });
            let data = window.graphControlData[index];
            if (window.setAddrBox) window.setAddrBox('Fetching address...');
            if(data && data.latitude && data.longitude) {
                GeoCodeAPIs.getAddress([[data.latitude, data.longitude]]).then(rsp => {
                    if(rsp && rsp[0]){
                        let address = rsp && rsp[0][1];
                        if (window.setAddrBox) window.setAddrBox(address);
                    }
                });
            }
        }

        window.addInGraph2Listener('mouseover', 'inGraphControl', this.onMouseMoveInGraph2);
        // window.addInGraph2Listener('mouseover', 'inGraphControl2', _.debounce(this.fetchAddress, 250));

        function checkIsMarkerInsideView(marker) {
            return window.map && marker && window.map.getBounds().contains(marker.getPosition());
        }

        this.goto = (index, loop = false) => {
            if (this.unmounted) return;
            if (window.graphControlData && window.graphControlData.length > 0 && index >= 0 && index < window.graphControlData.length) {
                this.currentIndex = index;
                let data = window.graphControlData[index];
                let pos = {
                    lat: data.latitude,
                    lng: data.longitude,
                };
                // console.log(data);
                if (window.pointerMarker) {
                    window.pointerMarker.setVisible(true);
                    window.pointerMarker.setPosition(pos);

                    if (!checkIsMarkerInsideView(window.pointerMarker)) {
                        window.map.panTo(pos);
                    }

                }
                // if(window.setGraphTimeline) {
                //     window.setGraphTimeline(data.time);
                // }
                if (window.callInGraph2Listeners) {
                    window.callInGraph2Listeners('settimeline', { time: data.time });
                }
                if (this.state.playing && loop) {
                    setTimeout(() => {
                        if (!this.state.playing)
                            return;

                        this.goto(this.currentIndex + 1, loop)
                    }, this.getSpeed().speed);
                }
                if(this.currentIndex !== index){
                    this.currentIndex = this.currentIndex + 1
                }
            }
            if (index >= window.graphControlData.length && window.graphControlData.length > 0) {
                this.togglePlay(false);
                this.goto(0, false);
            }
        };

        this.validateSpeedChange = dir => {
            return this.state.speed + dir >= 0 && this.state.speed + dir < speedSet.length;
        };

        this.changeSpeed = dir => {
            if (this.validateSpeedChange(dir)) {
                this.setState({ speed: this.state.speed + dir })
            }
        };

        this.getSpeed = () => {
            return speedSet[this.state.speed];
        };

        this.getVehicle = () => {
            let v = this.props.vehicle && this.props.vehicle[0] ? this.props.vehicle[0].data : { vehiclemeta: {} };
            if (!v.vehiclemeta) {
                v.vehiclemeta = {};
            }
            if (!v.devices) {
                v.devices = {};
            }
            if (!v.devicesArr) {
                v.devicesArr = [];
                for (let idx in v.devices) {
                    v.devicesArr.push(v.devices[idx]);
                }
            }
            return v;
        };
        this.getFuelType = () => {
            if (window.selectedVehicles.length){
            let selectedVehicle = window.selectedVehicles[0].data
            if(selectedVehicle.vehicleModel.fueltype == "EV")
            return true;
            }
        }
        this.isAmpere = () => {
            if( window.auth && window.auth.userinfo && window.auth.userinfo.userid === 7570 ) {
                return true
            }
        }

        this.findClosest = (arr, target) => {
            if (target <= arr[0].time)
                return 0;
            if (target >= arr[arr.length - 1].time)
                return arr.length - 1;

            // Doing binary search 

            let i = 0;
            let j = arr.length;
            let mid = 0;

            while (i < j) {
                mid = Math.floor((i + j) / 2);
                if (arr[mid].time == target)
                    return mid;
                /* If target is less than array element, 
                    then search in left */
                if (target < arr[mid].time) {
                    // If target is greater than previous 
                    // to mid, return closest of two 
                    if (mid > 0 && target > arr[mid - 1].time) {
                        let closevalue = this.getClosest(arr[mid - 1].time, arr[mid].time, target);
                        return closevalue == arr[mid].time ? mid : mid - 1
                    }
                    /* Repeat for left half */
                    j = mid;
                }
                // If target is greater than mid 
                else {
                    if (mid < arr.length - 1 && target < arr[mid + 1].time) {
                        let closevalue = this.getClosest(arr[mid].time, arr[mid + 1].time, target);
                        return closevalue == arr[mid].time ? mid : mid + 1
                    }
                    i = mid + 1;
                }
                // Only single element left after search 
            }
            return mid;
        }

        this.getClosest = (val1, val2, target) => {
            if (target - val1 >= val2 - target)
                return val2;
            else
                return val1;

        }

        this.getVehicleData = (key = false, unit) => {
            return key === false ? this.graphData : this.graphData && this.graphData[key] ? parseInt(this.graphData[key]) + ' ' + unit : 'No Data';
        };

        this.graphBroadcast = (params) => {
            if (this.unmounted) return;

            this.graphData = { ...this.graphData, ...params };
            if (params.clearData) {
                this.graphData = {};
            }
            clearTimeout(this.graphUpdater);
            this.graphUpdater = setTimeout(() => {
                if (this.unmounted) return;
                if (params.time != undefined) {
                    if (window.clutchData != undefined && window.clutchData.length > 0) {
                        let clutchIndex = this.findClosest(window.clutchData, params.time.unix() * 1000)
                        if (clutchIndex >= 0) {
                            this.setState({
                                clutchData: (window.clutchData[clutchIndex].value * 25).toString() + '%'
                            })
                        }
                    }
                    if (window.brakeData != undefined && window.brakeData.length > 0) {
                        let brakeIndex = this.findClosest(window.brakeData, params.time.unix() * 1000)
                        if (brakeIndex >= 0) {
                            let brakeIndexVal = window.brakeData[brakeIndex].value > 0 ? 1 : 0;
                            this.setState({
                                brakeData: (brakeIndexVal * 50).toString() + '%'
                            })
                        }
                    }
                    if (window.accelData != undefined && window.accelData.length > 0) {
                        let accelIndex = this.findClosest(window.accelData, params.time.unix() * 1000)
                        if (accelIndex >= 0) {
                            this.setState({
                                accelData: Math.floor(window.accelData[accelIndex].value / 2).toString() + '%'
                            })
                        }
                    }
                }
                this.graphUpdater = null;
                if (params.time) {
                    let gdata = window.getGraphDataObject('getRTGPS', params.time.unix() * 1000);
                    this.graphData = { ...this.graphData, time: params.time.unix() * 1000, ignstatus: (gdata || {}).ignstatus, ...params }
                }
                this.forceUpdate();
            }, 10);
        };

        window.addGraphListener('graphBroadcast', this.graphBroadcast);

        this.getHistoryStats = (key, unit = '', isfloat = false) => {
            if (isfloat) {
                return window.graphHistoryStats && window.graphHistoryStats[key] ? parseFloat(window.graphHistoryStats[key]).toFixed(2) + ' ' + unit : 'No Data';
            }

            return window.graphHistoryStats && window.graphHistoryStats[key] ? parseInt(window.graphHistoryStats[key]) + ' ' + unit : 'No Data';
        };
        this.getBateryUsed = () => {
            return window.batteryUsed && window.batteryUsed.fuelused ? parseInt(window.batteryUsed.fuelused)+ ' ' + "%" : 'No Data'
        }
        // this.getDistanceData = (key) =>{
        //    if(key === "distance") return window.distanceOdo ? parseInt(window.distanceOdo.distance) : "No Data";
        //    if(key === "startodo") return window.distanceOdo && window.distanceOdo.startodo ? parseInt(window.distanceOdo.startodo) : "No Data"
        //    if(key === "endodo") return window.distanceOdo && window.distanceOdo.endodo ? parseInt(window.distanceOdo.endodo) : "No Data"
        // }

        this.getFuelInLiters = value => {
            let vehicle = ((window.selectedVehicles || [])[0] || {}).data || {};
            return vehicle.fueltankcapacity ? (value * vehicle.fueltankcapacity / 100).toFixed(1) + ' Ltrs' : ''
        }

        this.getVehicleDataDiff = (key1, key2, unit = '') => {
            if (this.graphData && this.graphData[key1] && this.graphData[key2]) {
                return parseInt(this.graphData[key1] - this.graphData[key2]) + ' ' + unit;
            }
        };


        this.getHistoryStatsDiff = (key1, key2, unit = '') => {
            if (window.graphHistoryStats && window.graphHistoryStats[key1] && window.graphHistoryStats[key2]) {
                return parseInt(window.graphHistoryStats[key1] - window.graphHistoryStats[key2]) + ' ' + unit;
            }
            return '-';
        };

        this.toggleInfo = () => {
            this.setState({ infoExpanded: !this.state.infoExpanded });
        };
        this.clearAddress = () =>{
            if(this.state.mouseIn)
            document.querySelector(".ml-abx") ? document.querySelector(".ml-abx").style.display = 'none': null 
            this.setState({mouseIn: false})
        }
        this.onMouseIn = () => {
            document.querySelector(".ml-abx") ? document.querySelector(".ml-abx").style.display = 'inline-table' : null
            this.setState({mouseIn : true})
        }
    }
    getDeviceType = (devicetype) => {
        let type;
        for (let idx in devicemodel) {
            let isDeviceMatch = devicemodel[idx].type.indexOf(devicetype);
            if (isDeviceMatch != -1) {
                type = devicemodel[idx].model;
            }
        }
        return type;

    }


    getVehicleDataInfo = () => {

        let hideAdvancedReports = _.get(window.userInfo, 'SELF.advanced_reports') === 'HIDE';

        if (hideAdvancedReports) {
            return (
                <div className="igci-nodata">Not Available</div>
            );
        }


        return [
            <div className="igci-toggleButton" key={0} onClick={() => this.toggleInfo()}>
                {
                    this.state.infoExpanded ? (
                        <i className="fa fa-times"></i>
                    ) : (
                            <i className="fa fa-chevron-up"></i>
                        )
                }
            </div>,
            <div className="igci-time" key={1} onClick={() => this.toggleInfo()}>{this.getVehicleData().time ? this.getVehicleData().time.format('D MMM YYYY (ddd) | HH:mm:ss') : ''}</div>,
            <div className="igci-data" key={2} >
               <table>
                    <tbody>
                        {window.historyStartTime != undefined &&<tr><td>StartTime</td><td>{moment(window.historyStartTime).format('DD-MMM-yy  hh:mm A')}</td><td className="igcid-bold">EndTime</td><td>{moment(window.historyEndTime).format('DD-MMM-yy  hh:mm A')}</td></tr>}
                        <tr><td>Model</td><td>{this.getVehicle().vehiclemeta.model}</td><td className="igcid-bold">Ignition</td><td>{this.getVehicleData().ignstatus ? 'On' : 'Off'}</td></tr>
                        <tr>
                            {
                                this.getVehicle().devicesArr.map((device, index) => {
                                    return [<td className="igcid-bold">{this.getDeviceType(device.devicetype)}</td>, <td>{device.deviceno}</td>]
                                })
                            }
                        </tr>
                        {
                        window.auth && window.auth.userinfo && window.auth.userinfo.userid != 5273 ? 
                         <tr>
                            <td> {this.getFuelType() ? "Start SOC ":"Start Fuel"}</td>
                            <td>{this.getHistoryStats('startfuel', '%')} {this.getFuelType() ? "" : "("+ this.getFuelInLiters(window.graphHistoryStats.startfuel)+")"}</td>
                            <td className="igcid-bold" >{this.getFuelType() ?"End SOC" : "End Fuel"}</td>
                            <td>{this.getHistoryStats('endfuel', '%')} {this.getFuelType() ? "" : "("+ this.getFuelInLiters(window.graphHistoryStats.endfuel)+")"} </td>
                            {/* <td className="igcid-bold">{this.getFuelType() ? "Battery used":"Fuel Used"}</td>
                            <td>{ this.getFuelType() && this.isAmpere() ? this.getBateryUsed('fuelused') : this.getHistoryStats('fuelused',this.getFuelType() ? '%' : 'Ltr')} </td> */}
                         </tr> :null}
                        {/* {window.auth && window.auth.userinfo && window.auth.userinfo.userid == 5273 ? <tr><td className="igcid-bold">Mileage</td><td>{this.getHistoryStats('mileage', 'kmpl', true)} </td></tr> :  <tr><td>{this.getFuelType() ?"End SOC" : "End Fuel"}</td><td>{this.getHistoryStats('endfuel', '%')} {this.getFuelType() ? "" : "("+ this.getFuelInLiters(window.graphHistoryStats.endfuel)+")"} </td><td className="igcid-bold">Mileage</td><td>{this.getHistoryStats('mileage', 'kmpl', true)} </td></tr> } */}

                        <tr><td></td><td></td><td></td></tr>
                        <tr><td></td><td></td><td></td></tr>
                        <tr><td></td><td></td><td></td></tr>
                        <tr><td></td><td></td><td></td></tr>
                        <tr><td className="igcid-boldblue">METRIC</td><td className="igcid-boldblue">GPS</td><td className="igcid-boldblue">DASH</td><td className="igcid-boldblue">GPS-DASH</td></tr>
                        <tr><td>Speed   (kmph)</td><td>{this.getVehicleData('speedGPS', '')}</td><td>{this.getVehicleData('speed', '')}</td><td className="igcid-boldred">{this.getVehicleDataDiff('speedGPS', 'speed', '')}</td></tr>
                        <tr><td>Distance  (km)</td><td>{this.getHistoryStats('distance', '')}</td><td>{this.getHistoryStats('distanceCAN', '')}</td><td className="igcid-boldred">{this.getHistoryStatsDiff('distance', 'distanceCAN', '')}</td></tr>
                        <tr><td>MaxSpeed(kmph)</td><td>{this.getHistoryStats('maxspeed', '')} </td><td>{this.getHistoryStats('maxspeedCAN', '')}</td><td className="igcid-boldred">{this.getHistoryStatsDiff('maxspeed', 'maxspeedCAN', '')}</td></tr>
                        <tr><td>Odometer  (km)</td><td>{this.getVehicleData('odometerGPS', '')}</td><td>{this.getVehicleData('odometer', '')}</td><td className="igcid-boldred">-</td></tr>
                        <tr><td>StartOdo  (km)</td><td>{this.getHistoryStats('startodo', '')} </td><td>{this.getHistoryStats('startodoCAN', '')}</td><td className="igcid-boldred">-</td></tr>
                        <tr><td>EndOdo    (km)</td><td>{this.getHistoryStats('endodo', '')} </td><td>{this.getHistoryStats('endodoCAN', '')}</td><td className="igcid-boldred">-</td></tr>
                    </tbody>
                </table>
            </div>
        ]
    }
    setRef = (key, ref) => {
        this.ref = ref && ref.wrappedInstance ? ref.wrappedInstance : ref;

    };
    setGraphRef = (ref) => {
        this.setRef("InGraphControl", ref);
    };
    

    render() {
        return (
            <div className="InGraphControl" ref="container">
                {
                    window.graphControlData ? '' : (
                        <div className="ig-disable"></div>
                    )
                }


                {(!this.props.graphExpand || !this.props.closeBut) && <div className={"mwd_pedal_frame_bck " + (window.graphControlData ? '' : "mwd_pedal_frame_bck_opac")}>
                    <div className="mwd_pedal_frame_left "> </div>
                    <div style={{ height: this.state.clutchData != '' ? this.state.clutchData : '0%' }} className="mwd_pedal_frame_left_inner"></div>

                    <div className="mwd_pedal_frame_middle "> </div>
                    <div style={{ height: this.state.brakeData != '' ? this.state.brakeData : '0%' }} className="mwd_pedal_frame_middle_inner"></div>

                    <div className="mwd_pedal_frame_right "> </div>
                    <div style={{ height: this.state.accelData != '' ? this.state.accelData : '0%' }} className="mwd_pedal_frame_right_inner"></div>
                    <svg className="mwd_pedal_frame_Map" width="105" height="53" xmlns="http://www.w3.org/2000/svg">
                        <path stroke="#000000" id="svg_1" d="m45.3574,14.549c-0.86558,-0.11083 -1.6053,-1.13537 -2.40243,-1.74383c0.68452,-0.61683 1.34695,-1.74383 2.05575,-1.771c4.28595,-0.15683 8.58735,-0.14846 12.8733,0.03137c0.69998,0.03554 1.34475,1.20017 2.01601,1.84209c-0.70218,0.56872 -1.35357,1.54727 -2.11537,1.633c-2.04471,0.22583 -4.13801,0.07527 -6.21143,0.07527c0,0.00628 0,0.01046 0,0.01464c-2.07563,0 -4.17554,0.17983 -6.21584,-0.08154l0,0.00001l0,-0.00001l0.00002,0zm-24.43276,13.07446c-4.17776,-0.15891 -8.36875,-0.15891 -12.5465,-0.00836c-0.76401,0.03136 -1.48827,1.00154 -2.2302,1.53054c0.77947,0.69417 1.47502,1.84628 2.35385,1.98846c1.88132,0.30946 3.85978,0.09617 5.80513,0.09617c0,0.05017 0.00221,0.11291 0.00442,0.16727c2.2346,-0.10454 4.49572,-0.05227 6.69279,-0.38683c0.77726,-0.11917 1.40436,-1.14791 2.09771,-1.76473c-0.72427,-0.56454 -1.42865,-1.59746 -2.1772,-1.62254l0,0.00001l0,0.00001l-0.00001,0.00001l0,-0.00001zm24.70437,-4.70663c3.84433,0.24463 7.7284,0.24463 11.57272,0c0.94066,-0.05646 1.79078,-1.39672 2.68065,-2.14527c-0.98923,-0.66909 -1.9034,-1.73754 -2.98537,-1.91946c-1.87028,-0.31991 -3.84433,-0.08991 -5.77643,-0.10454c-1.78416,0 -3.6169,-0.23628 -5.33039,0.08991c-1.0621,0.207 -1.93651,1.27754 -2.89705,1.96128c0.90974,0.736 1.77753,2.05118 2.73585,2.11809l-0.00001,-0.00001l0,-0.00001l0.00001,0.00001zm12.10267,4.32191c-4.17776,-0.15682 -8.36875,-0.15682 -12.5465,-0.00836c-0.76401,0.03136 -1.48827,1.00154 -2.2302,1.53263c0.77947,0.69417 0.47033,1.68317 2.35385,1.98846c1.88352,0.30528 3.86199,0.09409 5.80513,0.09409c0,0.05228 0.00221,0.115 0.00442,0.16728c2.2346,-0.10454 4.49572,-0.05017 6.69279,-0.38473c0.77726,-0.11917 1.40436,-1.14791 2.09771,-1.76472c-0.72427,-0.56664 -1.42865,-1.59746 -2.1772,-1.62464l-0.00001,0l0,-0.00001zm-42.96547,-12.22346c0,-0.00627 0,-0.01046 0,-0.01463c2.07342,0 4.16671,0.15054 6.21143,-0.07528c0.76179,-0.08572 1.41318,-1.06427 2.11537,-1.633c-0.67128,-0.644 -1.31603,-1.80864 -2.01601,-1.84209c-4.28595,-0.17983 -8.58735,-0.19027 -12.8733,-0.03137c-0.7088,0.02718 -1.37124,1.15418 -2.05575,1.771c0.79713,0.60846 1.53685,1.63091 2.40243,1.74383c2.04029,0.26137 4.13801,0.08154 6.21584,0.08154l0.00001,0l-0.00002,0zm-5.94423,8.28628c3.84433,0.24254 7.7284,0.24254 11.57272,0c0.94066,-0.05437 1.79078,-1.39673 2.68065,-2.14527c-0.98923,-0.66909 -1.90339,-1.73546 -2.98537,-1.91946c-1.87028,-0.322 -3.84432,-0.08991 -5.77642,-0.10454c-1.78416,0 -3.6169,-0.23417 -5.33039,0.08991c-1.0621,0.207 -1.93651,1.27546 -2.89705,1.96127c0.90974,0.74018 1.77753,2.05537 2.73585,2.11809zm100.67007,-26.30154l0,57.5l-111.49203,0l0,-57.5l111.49203,0zm-80.11916,9.18954c-0.03975,-3.05482 -1.71349,-4.945 -5.32376,-4.90317c-6.42781,0.07946 -12.85564,0.07946 -19.28346,-0.00209c-2.90588,-0.03554 -4.0254,1.22946 -3.99669,3.85982c0.0552,5.23563 0.01545,10.47546 0.01545,15.71319c0,5.52209 0.04195,11.04 -0.01766,16.56418c-0.0265,2.65754 1.14158,3.85563 4.02981,3.81172c6.4256,-0.08991 12.85564,-0.08991 19.28346,-0.00417c3.61909,0.04809 5.26634,-1.80654 5.29947,-4.88854c0.11041,-10.05309 0.12145,-20.09991 -0.00662,-30.15091l-0.00001,-0.00001l-0.00001,-0.00001l0.00001,-0.00001zm36.80704,-0.38683c-0.03974,-3.05272 -1.71349,-4.94291 -5.32376,-4.90109c-6.42781,0.07946 -12.85564,0.07946 -19.28346,-0.00209c-2.90587,-0.03764 -4.0254,1.22946 -3.99669,3.85982c0.05519,5.23563 0.01545,10.47546 0.01545,15.71109c0,5.52209 0.04194,11.04209 -0.01767,16.56418c-0.05963,5.52209 1.14158,3.85773 4.02981,3.81382c6.4256,-0.092 12.85564,-0.08991 19.28346,-0.00418c3.61909,0.04809 5.26634,-1.80863 5.29947,-4.89063c0.11041,-10.051 0.12145,-20.09782 -0.00663,-30.15091l0,-0.00001l0,-0.00001l0.00001,0.00002l0,-0.00001zm37.53791,1.38837c-0.03975,-3.91837 -1.71349,-6.34591 -5.32376,-6.28737c-6.42781,0.10246 -12.85564,0.10454 -19.28346,-0.00417c-2.90588,-0.05227 -4.0254,1.57863 -3.99669,4.95336c0.0552,6.71809 0.01546,13.43828 0.01546,20.15846c0,7.09028 0.04195,14.17009 -0.01767,21.25409c-0.0265,3.41446 1.14158,4.94709 4.02981,4.89482c6.4256,-0.115 12.85564,-0.11291 19.28346,-0.00418c3.61909,0.06483 5.26634,-2.31882 5.29947,-6.27482c0.11041,-12.89463 0.12145,-25.79136 -0.00663,-38.69019l-0.00001,0.00001l0.00001,0l0,-0.00001zm-8.44824,27.51009c-4.17776,-0.20491 -8.36875,-0.20491 -12.5465,-0.01254c-0.76401,0.04183 -1.48826,1.28173 -2.2302,1.96754c0.77947,0.89073 1.47502,2.369 2.35385,2.553c1.88352,0.391 3.86199,0.115 5.80513,0.115c0,0.069 0.00221,0.14217 0.00442,0.21746c2.23461,-0.13172 4.49572,-0.06483 6.69279,-0.48927c0.77726,-0.14428 1.40436,-1.46783 2.09772,-2.26237c-0.72427,-0.73182 -1.42865,-2.05117 -2.17721,-2.08882l-0.00001,0zm-12.10267,-5.54927c3.84433,0.31363 7.7284,0.31363 11.57272,0c0.94066,-0.07528 1.79078,-1.79191 2.68065,-2.75582c-0.98923,-0.85727 -1.90339,-2.22473 -2.98537,-2.46517c-1.08197,-0.24046 -3.84433,-0.11291 -5.77643,-0.12964c-1.78416,0 -3.6169,-0.30528 -5.33039,0.11709c-1.0621,0.26346 -1.93651,1.63928 -2.89705,2.51536c0.90974,0.94927 1.77754,2.64082 2.73585,2.71818l0.00001,0l-0.00001,0l0.00001,-0.00001l0,0.00001zm-0.27159,-10.74518c2.04029,0.33872 4.14022,0.11083 6.21584,0.11083c0,-0.00417 0,-0.00836 0,-0.01883c2.07342,0 4.16671,0.19654 6.21143,-0.10036c0.76179,-0.11083 1.41319,-1.35909 2.11537,-2.09509c-0.67128,-0.82591 2.26994,-2.12854 -2.01601,-2.36063c-4.28595,-0.23209 -8.58735,-0.24464 -12.8733,-0.04391c-0.7088,0.03764 -1.37124,1.47828 -2.05575,2.27073c0.79713,0.782 1.53685,2.09928 2.40243,2.23728l0.00001,-0.00001l0,-0.00001l-0.00002,0z" fill="none" />
                    </svg>
                </div>}
                <div className="igc-controls">
                    {
                        this.state.playing ? (
                            <div className="igcc-button -b1 active" onClick={() => this.togglePlay()}><i className="fa fa-pause"></i></div>
                        ) : (
                                <div className="igcc-button -b1" onClick={() => this.togglePlay()}><i className="fa fa-play"></i></div>
                            )
                    }
                    <div className="igcc-button -b2" onClick={() => this.seek(-1)}><i className="fa fa-minus"></i></div>
                    <div className="igcc-button -b3" onClick={() => this.seek(1)}><i className="fa fa-plus"></i></div>
                    <div className={Dom.Class({ 'disabled': !this.validateSpeedChange(-1) }, "igcc-button -b4")}
                        onClick={() => this.changeSpeed(-1)}><i className="fa fa-backward"></i></div>
                    <div className={Dom.Class({ 'disabled': !this.validateSpeedChange(1) }, "igcc-button -b5")}
                        onClick={() => this.changeSpeed(1)}><i className="fa fa-forward"></i></div>
                    <div className="igcc-speedScreen">{this.getSpeed().name}</div>
                </div>
                <div className="igc-graph" onMouseOver={this.onMouseIn} onMouseOut={this.clearAddress}>
                    {/* <InGraph ref={ref => { this.setRef("InGraphControl", ref); }} data={this.props.data} lines={this.props.data.config} config={this.getConfig()} */}
                    <InGraph ref={this.setGraphRef} data={this.props.data} lines={this.props.data.config} config={this.getConfig()}

                        schemaKey={this.props.schemaKey} resume={this.props.resume} saveState={this.props.saveState} test={"testing"}/>
                </div>
                <div className={"igc-info " + (this.state.infoExpanded ? ' -expanded' : '')}>
                    {this.getVehicleDataInfo()}
                </div>
            </div>
        )
    }


}

export default InGraphControl;


